import React, { Component } from "react";
import { Route, Redirect } from "react-router";
import { Layout } from "./components/Layout";
import { Index } from "./components/Index";
import Login from "./components/login";
import { FAQ } from "./components/FAQ";
import { CodeOfConduct } from "./components/CodeOfConduct";
import { ConfidentialityAgreement } from "./components/ConfidentialityAgreement";

import { WorkOrderInt } from "./components/WorkOrderInt";
import { InterpreterAvailability } from "./components/InterpreterAvailability";
import { InterpreterAvailabilityAdmin } from "./components/InterpreterAvailabilityAdmin";
import { RepPortal } from "./components/RepPortal";
import { WorkOrderApi } from "./components/WorkOrderApi";
import { ClaimantApi } from "./components/ClaimantApi";
import { AuthorizeJob } from "./components/AuthorizeJob";

import { GetCookie } from "./components/utils/Common";

import "./custom.css";

export default class App extends Component {
  static displayName = App.name;

  render() {
    const href = window.location.href || "";
    let hasMagicLinkToken = false;

    try {
      const url = new URL(href);
      hasMagicLinkToken = !!url.searchParams.get("token");
    } catch (error) {
      hasMagicLinkToken = /[?&]token=([^&#]+)/i.test(href);
    }

    if (window.location.pathname.startsWith('/authorize-job')) {
      return <AuthorizeJob />;
    }

    return hasMagicLinkToken || GetCookie("user") === null || GetCookie("user") === undefined ? (
      <Login />
    ) : (
      <Layout>
        <Route exact path="/" render={() => {
          const user = JSON.parse(GetCookie("user"));
          return user.userrolename === 'Rep' ? <Redirect to="/rep-portal" /> : <Index />;
        }} />
        <Route path="/int-job" component={WorkOrderInt} />
        <Route path="/faq" component={FAQ} />
        <Route path="/code-of-conduct" component={CodeOfConduct} />
        <Route path="/confidentiality-agreement" component={ConfidentialityAgreement} />
        <Route path="/check-in" component={InterpreterAvailability} />
        <Route
          path="/int-availability"
          component={InterpreterAvailabilityAdmin}
        />
        <Route path="/rep-portal" component={RepPortal} />
        <Route path="/workorderapi" component={WorkOrderApi} />
        <Route path="/claimantapi" component={ClaimantApi} />
        {/*<Route path='/interpreter' component={Interpreter} />*/}
        {/*<Route path='/rep' component={Rep} />*/}
        {/*<Route path='/claimant' component={Claimant} />*/}
      </Layout>
    );
  }
}
